import React, { FC, Fragment, useState } from 'react';
import { IconButton, Menu as MuiMenu, MenuItem } from '@mui/material';
import MoreHorzIcon from '@mui/icons-material/MoreHoriz';
import { useTranslation } from 'react-i18next';

import { useDeleteWebhookMutation, Webhook, WebhookTypes } from 'api';

import useDeleteWebhook from 'features/admin/updaters/useDeleteWebhook';
import WorkVivoModal from './WorkVivoModal';
import GenericWebhookModal from './GenericWebhookModal';

const Menu: FC<Webhook> = ({ ...webhook }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isOpenWorkvivo, setIsOpenWorkvivo] = useState(false);
  const [isOpenGeneric, setIsOpenGeneric] = useState(false);

  const { t } = useTranslation();

  const mutationOptions = useDeleteWebhook();
  const { mutate } = useDeleteWebhookMutation({ ...mutationOptions });

  function handleWebhookMenuClick(event: React.MouseEvent<HTMLButtonElement>) {
    setAnchorEl(event.currentTarget);
  }

  function handleWebhookMenuClose() {
    setAnchorEl(null);
  }

  function handleDeleteWebhook() {
    mutate({ ...webhook });
  }

  function onClickEdit() {
    webhook.webhook_type === WebhookTypes.Workvivo
      ? setIsOpenWorkvivo(true)
      : setIsOpenGeneric(true);
    handleWebhookMenuClose();
  }

  return (
    <Fragment>
      <IconButton onClick={handleWebhookMenuClick} size="large">
        <MoreHorzIcon />
      </IconButton>
      <MuiMenu anchorEl={anchorEl} open={!!anchorEl} onClose={handleWebhookMenuClose}>
        <MenuItem onClick={onClickEdit}>{t('common:edit')}</MenuItem>
        <MenuItem onClick={handleDeleteWebhook}>{t('common:delete')}</MenuItem>
      </MuiMenu>

      {isOpenWorkvivo && (
        <WorkVivoModal isOpen={isOpenWorkvivo} setIsOpen={setIsOpenWorkvivo} {...webhook} />
      )}
      {isOpenGeneric && (
        <GenericWebhookModal isOpen={isOpenGeneric} setIsOpen={setIsOpenGeneric} {...webhook} />
      )}
    </Fragment>
  );
};

export default Menu;
